// const BASE_URL = "http://192.168.7.37:8001/node_api/";
//const BASE_URL = "http://162.19.146.132:1428/node_api/"
const DEFAULT_KEY = '14959'
const BASE_URL = "https://admin.gorealtygi.com/node_api/"





const PAYPAL_CLIENT_ID = ""

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }
